import localforage from "localforage";
import pinsData from "./pins"; // Importing the list of pins
import { STORAGE_KEYS } from "./constants/storage";

export const saveVisitedPin = async (name) => {
  try {
    const visitedPins =
      (await localforage.getItem(STORAGE_KEYS.VISITED_PINS)) || [];
    if (!visitedPins.includes(name)) {
      visitedPins.push(name);
      await localforage.setItem(STORAGE_KEYS.VISITED_PINS, visitedPins);
    }
  } catch (error) {
    console.error("Error saving visited pin:", error);
  }
};

export const getVisitedPins = async () => {
  try {
    return (await localforage.getItem(STORAGE_KEYS.VISITED_PINS)) || [];
  } catch (error) {
    console.error("Error loading visited pins:", error);
    return [];
  }
};

export const loadVisitedPins = async () => {
  try {
    const visitedPins = await getVisitedPins();
    pinsData.forEach((pin) => {
      if (visitedPins.includes(pin.name)) {
        pin.visited = true;
      }
    });
  } catch (error) {
    console.error("Error restoring pin state:", error);
  }
};
